import { CheckCircle, XCircle, Minus, FlaskConical } from 'lucide-react';
import type { ValidationFieldResult } from '../../types/barcodeValidation';

interface Props {
  results: ValidationFieldResult[] | null;
  onValidate: () => void;
  canValidate: boolean;
}

export function ValidationResultsPanel({ results, onValidate, canValidate }: Props) {
  const passCount = results?.filter((r) => r.match === true).length ?? 0;
  const failCount = results?.filter((r) => r.match === false).length ?? 0;
  const skipCount = results?.filter((r) => r.match === null).length ?? 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold text-gray-800">Resultado da Validacao</h2>
        <button
          onClick={onValidate}
          disabled={!canValidate}
          className="flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors text-sm font-medium"
        >
          <FlaskConical className="w-4 h-4" />
          Validar
        </button>
      </div>

      {!results ? (
        <p className="text-sm text-gray-400 italic">Parseie o codigo e preencha os dados esperados, depois clique &quot;Validar&quot;</p>
      ) : (
        <>
          <div className="flex gap-4 mb-4 text-sm">
            <span className="flex items-center gap-1 text-green-600">
              <CheckCircle className="w-4 h-4" /> {passCount} OK
            </span>
            <span className="flex items-center gap-1 text-red-600">
              <XCircle className="w-4 h-4" /> {failCount} Falha
            </span>
            <span className="flex items-center gap-1 text-gray-400">
              <Minus className="w-4 h-4" /> {skipCount} N/A
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-2 px-3 text-gray-500 font-medium">Campo</th>
                  <th className="text-left py-2 px-3 text-gray-500 font-medium">Parseado</th>
                  <th className="text-left py-2 px-3 text-gray-500 font-medium">Esperado</th>
                  <th className="text-center py-2 px-3 text-gray-500 font-medium">Resultado</th>
                </tr>
              </thead>
              <tbody>
                {results.map((r) => (
                  <tr key={r.field} className="border-b border-gray-100 last:border-0">
                    <td className="py-2 px-3 font-medium text-gray-700">{r.label}</td>
                    <td className="py-2 px-3 font-mono text-gray-600">{r.parsedValue || <span className="text-gray-300">-</span>}</td>
                    <td className="py-2 px-3 font-mono text-gray-600">{r.expectedValue || <span className="text-gray-300">-</span>}</td>
                    <td className="py-2 px-3 text-center">
                      {r.match === true && <CheckCircle className="w-5 h-5 text-green-500 inline" />}
                      {r.match === false && <XCircle className="w-5 h-5 text-red-500 inline" />}
                      {r.match === null && <Minus className="w-5 h-5 text-gray-300 inline" />}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
